<template>
  <v-row>
    <v-col
      cols="4"
      style="height: calc(100vh - 300px); overflow: scroll"
      class="py-0"
    >
      <sfr-list
        :start-date="headerProps.startDate"
        :end-date="headerProps.endDate"
        :destination-id="headerProps.destinationId"
        :agent-id="headerProps.agentId"
        :department="headerProps.department"
        :adults="headerProps.dults"
        :children="headerProps.children"
        :infants="headerProps.infants"
        :supplier-type="addServiceSupplierType"
        drag-and-drop
      ></sfr-list>
    </v-col>
    <v-col
      cols="8"
      style="height: calc(100vh - 300px); overflow: scroll"
      class="pt-0"
    >
      <v-container pt-0 v-if="false">
        <v-row justify="end">
          <v-switch dense label="Auto Add" v-model="headless" hide-details />
        </v-row>
      </v-container>

      <itinerary-builder-drag-and-drop-day
        v-for="day in duration"
        :key="day"
        :day="day"
        :items="items"
        :start-date="headerProps.startDate"
        @change="onDayChange"
        @item-delete="onItemDelete"
        @item-edit="onItemEdit"
        @item-changed="onItemChanged"
        :max-duration="duration - day"
      ></itinerary-builder-drag-and-drop-day>
      <div v-if="debug">{{ items }}</div>
    </v-col>
  </v-row>
</template>

<script>
import ItineraryBuilderDragAndDropDay from "./ItineraryBuilderDragAndDropDay.vue";
import SfrList from "./sfr/SFRList.vue";
const moment = require("moment");
export default {
  name: "itinerary-builder-drag-and-drop",
  props: {
    headerProps: {
      type: Object,
      default: () => {},
    },
    items: {
      type: Array,
      default: () => [],
    },
  },

  components: { SfrList, ItineraryBuilderDragAndDropDay },

  data() {
    return {
      debug: false,
      addServiceSupplierType: "ACCOMMODATION",
      headless: true,
    };
  },

  computed: {
    duration() {
      if (this.headerProps.startDate && this.headerProps.endDate) {
        const start = moment(this.headerProps.startDate).startOf("day");
        const end = moment(this.headerProps.endDate).startOf("day");
        if (start.isValid() && end.isValid()) {
          return end.diff(start, "days") + 1;
        }
      }
      return 1;
    },
  },

  methods: {
    onDayChange(payload) {
      if (payload.added) {
        payload.added.element.headless = this.headless;
      }
      this.$emit("change", payload);
    },
    onItemDelete(item) {
      this.$emit("item-delete", item);
    },
    onItemEdit(item) {
      this.$emit("item-edit", { ...item, headless: false });
    },
    onItemChanged(payload) {
      this.$emit("item-changed", payload);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/ItineraryBuilderDragAndDrop.vue